import {
  fptiCustomImpression,
  fptiCustomSetup,
  fptiCustomClick,
  getFptiPage,
} from './fpti'
import serverData from './server-data'
import {
  isFeatureEnabled,
  getFeatureValue,
  isFeatureNotEnabled,
  isStateFeatureEnabled,
} from './remote-config'
import { getTreatmentDataByName, hasTreatmentName } from './treatment-name'
import { isEmail, isEmptyOrWhiteSpace } from './validation'
import { modalStyleConfig } from './modal'

const scrollToView = (domelement) => {
  setTimeout(() => {
    const element = document.querySelector(domelement)
    element.scrollIntoView({
      behavior: 'smooth',
    })
  }, 0)
}

const getDirectionality = () => {
  const { locality = {} } = serverData
  return locality.directionality || 'ltr'
}

export {
  fptiCustomImpression,
  fptiCustomClick,
  isFeatureEnabled,
  isFeatureNotEnabled,
  isStateFeatureEnabled,
  serverData,
  hasTreatmentName,
  getFptiPage,
  getTreatmentDataByName,
  getFeatureValue,
  fptiCustomSetup,
  isEmail,
  isEmptyOrWhiteSpace,
  modalStyleConfig,
  scrollToView,
  getDirectionality,
}
